"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderSuggestionButton = exports.resolveSuggestionValue = exports.suggestionButtonStyles = void 0;
const lit_1 = require("lit");
/** chat-suggestion·search-suggestion이 공유하는 host 레이아웃. */
exports.suggestionButtonStyles = (0, lit_1.css) `
  :host {
    display: inline-flex;
  }
`;
/** 추천어가 알릴 값. value를 주지 않으면 슬롯에 적은 글자를 쓴다. */
function resolveSuggestionValue(host) {
    return host.value || host.textContent?.trim() || '';
}
exports.resolveSuggestionValue = resolveSuggestionValue;
/** mm-button(tertiary, small)을 감싸고 클릭을 위임하는 추천 버튼 조립. 발행 이벤트 이름만 각 컴포넌트가 소유한다. */
function renderSuggestionButton(icon, onClick) {
    return (0, lit_1.html) `
    <mm-button variant="tertiary" icon=${icon} @click=${onClick}>
      <slot></slot>
    </mm-button>
  `;
}
exports.renderSuggestionButton = renderSuggestionButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3VnZ2VzdGlvbi1idXR0b24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzdWdnZXN0aW9uLWJ1dHRvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBK0I7QUFJL0IseURBQXlEO0FBQzVDLFFBQUEsc0JBQXNCLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Q0FJeEMsQ0FBQTtBQUVELDhDQUE4QztBQUM5QyxTQUFnQixzQkFBc0IsQ0FBQyxJQUFxQztJQUMxRSxPQUFPLElBQUksQ0FBQyxLQUFLLElBQUksSUFBSSxDQUFDLFdBQVcsRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLENBQUE7QUFDckQsQ0FBQztBQUZELHdEQUVDO0FBRUQsa0ZBQWtGO0FBQ2xGLFNBQWdCLHNCQUFzQixDQUFDLElBQTBCLEVBQUUsT0FBbUI7SUFDcEYsT0FBTyxJQUFBLFVBQUksRUFBQTt5Q0FDNEIsSUFBSSxXQUFXLE9BQU87OztHQUc1RCxDQUFBO0FBQ0gsQ0FBQztBQU5ELHdEQU1DIn0=